export default {
	path: '/register-user',
	redirect: '/register-user',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'registerUserHome',
			component: () => import('@/views/mng/RegisterUser'),
		},
	],
};
